import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import axios from 'axios';
import { CSVDownload } from 'react-csv';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import {
  DisplayGuid,
} from '../items';
import AddEntityButton from '../misc/AddEntityButton';

const resultsCount = 15;

class ReportsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  componentDidMount() {
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { reports: { searchReport } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchReport({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const { history } = this.props;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Reports page'
              documentDescription='Reports page'
            />

            <h2 className='main-page-header'>
              Reports
              <AddEntityButton to='/sales-report' />
            </h2>

            {/* <Filters
              initFromUrl
              submitUrl
              validateForm={({
                reportId,
                name,
                type,
                category
              }, updatedKey) => {
                if (updatedKey !== 'reportId') {
                  return {
                    name,
                    type,
                    category
                  };
                }
                return { reportId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='reportId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='reportId'
                      placeholder='Find by id'
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            /> */}
            {
                this.state.downloadReport ? <CSVDownload key={new Date().getTime()} data={this.state.downloadReport} target="_blank" /> : ''
            }
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'reports',
                rowClasses: 'hover-listview',
                // rowClick: ({ Id }) => {
                //   history.push(`/report/${Id}`);
                // },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'IncludeCancellations',
                    label: 'With Cancellations',
                    render: ({ IncludeCancellations }) => IncludeCancellations ? 'yes' : 'no'
                  },
                  {
                    property: 'ReportByActivityDate',
                    label: 'By Activity Date',
                    render: ({ ReportByActivityDate }) => ReportByActivityDate ? 'yes' : 'no'
                  },
                  {
                    property: 'RequestedTime',
                    label: 'Requested At'
                  },
                  {
                    property: 'CompletedTime',
                    label: 'Completed At'
                  },
                  {
                    property: 'StartDate',
                    label: 'From'
                  },
                  {
                    property: 'EndDate',
                    label: 'To'
                  },
                  {
                    property: 'Download',
                    label: 'Download',
                    render: ({ Id }) => { 
                      const storageUrl = document.location.hostname === 'admin.wannasport.com'
                        ? 'wsstorageproduction'
                        : 'wsstoragestaging'; // TODO: read from config
                      return (<a style={{ color: 'red' }} onClick={
                        async () => { 
                          const { data, Error } = await axios.get(`https://${storageUrl}.blob.core.windows.net/reports/${Id}`);

                          if (data === '') {
                            alert('Report is empty');

                            return;
                          }

                          this.setState({ downloadReport: data });
                        }}>Download</a>);
                    }
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);

                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Reports = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ReportsInternal)
));

Reports.requiresLogin = true;
Reports.propTypes = { isLoggedIn: PropTypes.bool };

export default Reports;